module.exports = __webpack_public_path__ + "img/ceo2.1a212ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ceo2.png
// module id = 1c1q
// module chunks = 0